module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_packs.c0a98444259779980442fe8c1bea6667.png";